<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="w-32 px-4">
            {{ issueDate }}
          </div>
          <div class="flex-1 px-4">
            {{ payment.recipientName }}
          </div>
          <div class="flex-1 px-4">
            {{ payment.issuerName }}
          </div>
          <div class="flex-1 px-4">
            {{ payment.notes }}
          </div>
          <div class="w-32 px-4 text-right">{{ payment.amount || 0 }} &euro;</div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!payment.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('payment:view', payment)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  props: {
    payment: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.payment.accountUuid] || null;
      },
      accountRelation({ accountRelations }) {
        return accountRelations.byId[this.payment.accountRelationUuid] || null;
      },
      issueDate() {
        return moment(this.payment.issueDate).format('DD/MM/YYYY');
      },
    }),
  },
};
</script>
